import constantRoutes from '@/router';
import Utils from '@/utils/utils';
import Constants from '@/constants/constants';
import {getMenusButtons, getMenusButtonsByRole} from '@/apis/auth/move-auth/platform/menu';
/**
 * 把后台返回菜单组装成routes要求的格式
 * @param {*} routes
 */

export function getAsyncRoutes(routes, resultRoutes = []) {
  routes && routes.forEach((item) => {
    const newItem = {};
    if (item.menuUrl) {
      item.menuUrl = !item.menuUrl.startsWith('/') ? `/${item.menuUrl}` : item.menuUrl
      if (!Number(item.isFrame)) {
        // newItem.component = () =>
        //     import(
        //         `@/${item.pagePath.indexOf('.vue') > 0
        //             ? item.pagePath
        //             : item.pagePath + '.vue'
        //         }`
        //     );
        newItem.path = Constants.FlowDesignDetailRoutes.includes(item.menuCode) || Constants.SystemDetailRoutes.includes(item.menuCode)  ? `${process.env.VUE_APP_BASE_URL}${item.menuUrl}/:id` : `${process.env.VUE_APP_BASE_URL}${item.menuUrl}`;
      } else {
        newItem.component = () => import(`@/components/move-path/layout/IFrame.vue`);
        newItem.path = `/iframe/${item.menuNo}`;
      }
      newItem.name = item.menuCode;
      newItem.meta = {
        title: item.menuName,
        isFrame: item.isFrame,
        menuUrl: item.menuUrl,
        isVisible: item.isVisible,
        menuIcon: item.menuIcon,
        menuNo: item.menuNo,
        requireAuth: true
      };
      resultRoutes.push(newItem);
    }
    if (item.children && item.children.length) {
      getAsyncRoutes(item.children, resultRoutes);
    }
  });
  return resultRoutes;
}
const types = {
  SET_ROUTES: 'SET_ROUTES',
  GET_FIRST_ROUTE: 'GET_FIRST_ROUTE',
  CLEAR_ROUTES: 'CLEAR_ROUTES',
  GET_MENUS: 'GET_MENUS',
  GET_MENUS_AND_BUTTONS: 'GET_MENUS_AND_BUTTONS',
  get_CUR_SECOND_MENUS: 'get_CUR_SECOND_MENUS'
};

const state = {
  routes: [],
  dynamicRoutes: [],
  hasDynamicRoutes: false,
  allRoutes: [],
  menus: [],
  btnPermissions: {},
  firstRoute: {},
  menusAndButtons: [],
  curSecondMenus: [] 
  //子级菜单
};

const actions = {
  async generateRoutes({ commit }) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve) => {
      let routes = [];
      let dynamicRoutes = JSON.parse(sessionStorage.getItem('dynamicRoutes'));
      if (!dynamicRoutes || (dynamicRoutes && dynamicRoutes.length < 1)) {
        let lastDecision = Utils.Local.getObject('lastDecision');
        let routesAndButtons = lastDecision?.userNo
          ? await getMenusButtonsByRole()
          : { menus: [], buttons: [] }; 
          // 获取到后台路由
        // let routesAndButtons = menuJson;
        routes = routesAndButtons.menus;
        sessionStorage.setItem('dynamicRoutes', JSON.stringify(routes));
        sessionStorage.setItem('btnPermissions', JSON.stringify(routesAndButtons.buttons));
      } else {
        routes = dynamicRoutes;
      }
      const asyncRoutes = getAsyncRoutes(routes); 
      // 对路由格式进行处理
      commit(types.SET_ROUTES, asyncRoutes);
      commit(types.GET_MENUS, routes);
      resolve(asyncRoutes);
    });
  },
  clearRoutes({ commit }) {
    sessionStorage.removeItem('sysDictRoutes');
    commit(types.CLEAR_ROUTES);
  },
  async getMenusAndButtons(context, params) {
    let res = await getMenusButtons(params);
    context.commit(types.GET_MENUS_AND_BUTTONS, res);
    return res;
  },
  getSecondMenus(context, routeInfo) {
    const { from, to } = routeInfo;
    // 当to为一级菜单时候，不需要判断
    const toIsFirstMenu = context.state.dynamicRoutes.find((i) => i.name === to.name);
    const toRouteName = to.name;
    let res = [];
    if (toIsFirstMenu?.meta.isVisible === '1') {
      res = []
    } else {
      res = recursiveMenus(toRouteName, context.state.allRoutes);
    }
    context.commit(types.get_CUR_SECOND_MENUS, res);
    return res;
  }
};

const mutations = {
  [types.SET_ROUTES]: (state, routes) => {
    state.dynamicRoutes = routes;
    state.hasDynamicRoutes =  state.dynamicRoutes.length > 0;
    state.routes = constantRoutes.concat(routes);
  },
  [types.GET_FIRST_ROUTE](state, payload) {
    state.firstRoute = payload;
  },
  [types.CLEAR_ROUTES](state) {
    state.dynamicRoutes = [];
    state.routes = [];
    state.allRoutes = [];
    state.menus = [];
  },
  [types.GET_MENUS](state, routes) {
    state.allRoutes = routes ? JSON.parse(JSON.stringify(routes)) : [];
    state.menus = removeHiddenMenus(routes);
  },
  [types.GET_MENUS_AND_BUTTONS](state, payload) {
    state.menusAndButtons = payload;
  },
  [types.get_CUR_SECOND_MENUS](state, payload) {
    state.curSecondMenus = payload;
  }
};
export function findFirstRoute(dynamicRoutes, route = '') {
  let firstRoute = route;
  for (let i = 0; i < dynamicRoutes.length; i++) {
    if (dynamicRoutes[i].menuUrl && dynamicRoutes[i].menuCode) {
      firstRoute = dynamicRoutes[i];
      return firstRoute;
    } else if (dynamicRoutes[i].children && dynamicRoutes[i].children.length > 0) {
      return findFirstRoute(dynamicRoutes[i].children, firstRoute);
    }
  }
  return firstRoute;
}
// 找到特定的menu对象
function recursiveMenus(routeName, menus = []) {
  for (let menu of menus || []) {
    let { children, ...self } = menu;
    let res = [];
    if (menu.children && menu.children.find((i) => i.menuCode === routeName)) {
      menu.children && menu.children.forEach((i) => {
        const { children, ...rest } = i;
        if (i.menuStat === '1' && i.menuUrl) {
          res.push(rest);
        }
      });
      return {
        parentMenu: {
          ...self,
          menuUrl:  process.env.VUE_APP_BASE_URL + self.menuUrl
        },
        children: res
      };
    }
    if (menu.children) {
      const result = recursiveMenus(routeName, menu.children)
      if (result) return result
    }
  }
}
const getters = {
  routes: (state) => state.routes,
  dynamicRoutes: (state) => state.dynamicRoutes,
  hasDynamicRoutes:  (state) => state.hasDynamicRoutes,
  menus: (state) => state.menus,
  allMenus: (state) => {
    return state.allRoutes;
  },
  btnPermissions: () => {
    return Utils.Session.getItem('btnPermissions') !== '{}'
      ? Utils.Session.getObject('btnPermissions')
      : {};
  },
  firstRoute: (state) => state.firstRoute,
  menusAndButtons: (state) => state.menusAndButtons,
  curSecondMenus: (state) => state.curSecondMenus
};

export function removeHiddenMenus(showList) {
  if (typeof showList === 'object') {
    // 如果showList是一个object，遍历showList
    for (let i = 0; i < showList.length; i++) {
      let element = showList[i];
      if (!element.isVisible || element?.isVisible === '0') {
        showList.splice(i, 1);
        // 注意删除了一项后，索引-1
        i--;
      } else if (element.children && element.children.length > 0) {
        // 遍历其子节点
        element.children.forEach(n => {
          n.menuUrl = `${process.env.VUE_APP_BASE_URL}${n.menuUrl}`;
        })
        removeHiddenMenus(element.children);
      }
    }
    return showList;
  } else {
    // 子节点不存在则结束
    return;
  }
}
export default {
  namespaced: true,
  cacheName:'permission',
  state,
  mutations,
  actions,
  getters
};
